// src/router/index.js
import { createRouter, createWebHashHistory } from 'vue-router'
import LoginPage from '../views/LoginPage.vue'
import AppLayout from '../views/AppLayout.vue'

// ========== Management 部门页面 ==========
import ManagementMain from '../views/management/ManagementMain.vue'
import ManagementOrderMonitor from '../views/management/ManagementOrderMonitor.vue'
import ManagementPortDetails from '../views/management/ManagementPortDetails.vue'
import ManagementVesselInspection from '../views/management/ManagementVesselInspection.vue'

// ========== Finance 部门页面 ==========
import FinanceMain from '../views/finance/FinanceMain.vue'
import FinanceMonitoring from '../views/finance/FinanceMonitoring.vue'
import FinancePortDetails from '../views/finance/FinancePortDetails.vue'
import FinanceVesselInspection from '../views/finance/FinanceVesselInspection.vue'

// ========== Market 部门页面 ==========
import MarketingMain from '../views/market/MarketingMain.vue'
import MarketingPortDetails from '../views/market/MarketingPortDetails.vue'

// ========== Operation 部门页面 ==========
import OperationMain from '../views/operation/OperationMain.vue'
import OrderMonitoring from '../views/operation/OrderMonitoring.vue'
import OperationPortDetails from '../views/operation/OperationPortDetails.vue'

// ========== 修改密码页面 ==========
import ChangePassword from '../views/ChangePassword.vue'

// 角色到主页的映射
const mainMap = {
    management: '/management/main',
    finance: '/finance/main',
    market: '/market/main',
    operation: '/operation/main'
}

const routes = [
    {
        path: '/login',
        name: 'Login',
        component: LoginPage,
        meta: { title: 'Login', requiresAuth: false }
    },
    {
        path: '/change-password',
        name: 'ChangePassword',
        component: ChangePassword,
        meta: { title: '修改密码', requiresAuth: true }
    },
    {
        path: '/',
        component: AppLayout,
        meta: { requiresAuth: true },
        children: [
            {
                path: '',
                // ⭐ 修复：动态重定向
                redirect: to => {
                    const token = localStorage.getItem('token')
                    if (!token) {
                        return '/login'
                    }
                    const userRole = localStorage.getItem('userRole') || 'management'
                    return mainMap[userRole] || '/management/main'
                }
            },

            // ===== Management 部门 =====
            {
                path: 'management/main',
                name: 'ManagementMain',
                component: ManagementMain,
                meta: { title: 'Management Main', requiresAuth: true, role: 'management' }
            },
            {
                path: 'management/vessel-inspection',
                name: 'ManagementVesselInspection',
                component: ManagementVesselInspection,
                meta: { title: 'Vessel Inspection', requiresAuth: true, role: 'management' }
            },
            {
                path: 'management/order-monitor',
                name: 'ManagementOrderMonitor',
                component: ManagementOrderMonitor,
                meta: { title: 'Order Monitoring', requiresAuth: true, role: 'management' }
            },
            {
                path: 'management/port-details',
                name: 'ManagementPortDetails',
                component: ManagementPortDetails,
                meta: { title: 'Port Details', requiresAuth: true, role: 'management' }
            },

            // ===== Finance 部门 =====
            {
                path: 'finance/main',
                name: 'FinanceMain',
                component: FinanceMain,
                meta: { title: 'Finance Main', requiresAuth: true, role: 'finance' }
            },
            {
                path: 'finance/vessel-inspection',
                name: 'FinanceVesselInspection',
                component: FinanceVesselInspection,
                meta: { title: 'Vessel Financial Inspection', requiresAuth: true, role: 'finance' }
            },
            {
                path: 'finance/monitoring',
                name: 'FinanceMonitoring',
                component: FinanceMonitoring,
                meta: { title: 'Finance Monitoring', requiresAuth: true, role: 'finance' }
            },
            {
                path: 'finance/proceeding',
                redirect: '/finance/monitoring'
            },
            {
                path: 'finance/port-details',
                name: 'FinancePortDetails',
                component: FinancePortDetails,
                meta: { title: 'Port Details', requiresAuth: true, role: 'finance' }
            },

            // ===== Market 部门 =====
            {
                path: 'market/main',
                name: 'MarketingMain',
                component: MarketingMain,
                meta: { title: 'Marketing Main', requiresAuth: true, role: 'market' }
            },
            {
                path: 'market/port-details',
                name: 'MarketingPortDetails',
                component: MarketingPortDetails,
                meta: { title: 'Port Details', requiresAuth: true, role: 'market' }
            },

            // ===== Operation 部门 =====
            {
                path: 'operation/main',
                name: 'OperationMain',
                component: OperationMain,
                meta: { title: 'Operation Main', requiresAuth: true, role: 'operation' }
            },
            {
                path: 'operation/order-monitoring',
                name: 'OrderMonitoring',
                component: OrderMonitoring,
                meta: { title: 'Order Monitoring', requiresAuth: true, role: 'operation' }
            },
            {
                path: 'operation/order-proceeding',
                redirect: '/operation/order-monitoring'
            },
            {
                path: 'operation/new-order',
                redirect: '/operation/order-monitoring'
            },
            {
                path: 'operation/order-completion',
                redirect: '/operation/order-monitoring'
            },
            {
                path: 'operation/port-details',
                name: 'OperationPortDetails',
                component: OperationPortDetails,
                meta: { title: 'Port Details', requiresAuth: true, role: 'operation' }
            }
        ]
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: () => import('../views/NotFound.vue'),
        meta: { title: '404 - 页面未找到' }
    }
]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

// ========== 全局前置守卫 ==========
router.beforeEach((to, from, next) => {
    // 设置页面标题
    if (to.meta && to.meta.title) {
        document.title = `${to.meta.title} - NSHIPS OMS`
    }

    const token = localStorage.getItem('token')
    const userRole = localStorage.getItem('userRole') || 'management'
    const defaultMainPath = mainMap[userRole] || '/management/main'

    // ===== 1. 防止重复导航 =====
    if (from.path === to.path) {
        next()
        return
    }

    // ===== 2. 如果已经是默认主页，直接放行 =====
    if (to.path === defaultMainPath && token) {
        next()
        return
    }

    // ===== 3. 处理根路径（由 redirect 处理，但保留兜底） =====
    if (to.path === '/') {
        if (token) {
            next(defaultMainPath)
        } else {
            next('/login')
        }
        return
    }

    // ===== 4. 处理登录页 =====
    if (to.path === '/login') {
        if (token) {
            next(defaultMainPath)
        } else {
            next()
        }
        return
    }

    // ===== 5. 处理修改密码页 =====
    if (to.path === '/change-password') {
        if (token) {
            next()
        } else {
            next('/login')
        }
        return
    }

    // ===== 6. 需要认证的路由 =====
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!token) {
            next({ path: '/login', query: { redirect: to.fullPath } })
            return
        }

        const requiredRole = to.meta.role
        if (requiredRole && userRole && userRole !== requiredRole) {
            if (to.path === defaultMainPath) {
                next()
                return
            }
            next(defaultMainPath)
            return
        }

        next()
    } else {
        next()
    }
})

// ========== 全局后置钩子 ==========
router.afterEach((to) => {
    console.log(`📍 跳转到: ${to.path}`)
})

export default router